"use client";

import { getPrimaryLabel, type ProductPrimarySelection } from "@/data/product-categories";

type Tone = "light" | "dark";

/**
 * Category art from `/public/categories/{primary}.png`.
 * Single `<img>` — no frame, no border, no fixed-size box (avoids any letterboxing read as “black”).
 */
export function CategoryScene3D(props: { primary: ProductPrimarySelection; tone?: Tone }) {
  const { primary } = props;

  if (!primary) {
    return (
      <div
        className="pointer-events-none block h-[15.4rem] w-auto max-w-[min(100%,16.8rem)] shrink-0 sm:h-[18.2rem] sm:max-w-[19.6rem]"
        aria-hidden
      />
    );
  }

  const label = getPrimaryLabel(primary);

  return (
    <img
      key={primary}
      src={`/categories/${primary}.png`}
      alt={label}
      className="pointer-events-none block h-[15.4rem] w-auto max-w-[min(100%,16.8rem)] shrink-0 object-contain sm:h-[18.2rem] sm:max-w-[19.6rem]"
      style={{ backgroundColor: "transparent", boxShadow: "none", border: "none", outline: "none", pointerEvents: "none" }}
      draggable={false}
      decoding="sync"
      loading="eager"
    />
  );
}
